import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const FIELDS = [
  ["mot_due", "MOT expiry", "date"], ["tax_due", "Tax due", "date"], ["insurance_insurer", "Insurer", "text"],
  ["insurance_policy", "Policy number", "text"], ["insurance_expiry", "Insurance expiry", "date"],
  ["service_interval_months", "Service interval (months)", "number"], ["service_interval_miles", "Service interval (miles)", "number"],
  ["next_service_date", "Next service date", "date"], ["next_service_miles", "Next service at (miles)", "number"],
];

export const ComplianceDialog = ({ bike, onClose, onSaved }) => {
  const [f, setF] = useState(Object.fromEntries([...FIELDS.map(([k]) => [k, bike[k] ?? ""]), ["tax_status", bike.tax_status || ""]]));
  const save = async (e) => {
    e.preventDefault();
    const body = {};
    Object.entries(f).forEach(([k, v]) => {
      const type = FIELDS.find((x) => x[0] === k)?.[2];
      body[k] = v === "" ? null : type === "number" ? Number(v) : v;
    });
    try {
      const { data } = await api.patch(`/bikes/${bike.id}/compliance`, body);
      toast.success("Compliance details saved");
      onSaved(data);
      onClose();
    } catch (err) { toast.error(errMsg(err)); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-h-[92vh] overflow-y-auto sm:max-w-2xl" data-testid="compliance-dialog">
        <DialogHeader><DialogTitle className="font-display text-2xl">MOT, tax, insurance & service</DialogTitle></DialogHeader>
        <form onSubmit={save} className="grid gap-4 sm:grid-cols-2">
          <div className="space-y-1.5"><Label>Tax status</Label>
            <Select value={f.tax_status || undefined} onValueChange={(v) => setF({ ...f, tax_status: v })}>
              <SelectTrigger data-testid="compliance-tax-status"><SelectValue placeholder="Select" /></SelectTrigger>
              <SelectContent>{["taxed", "sorn", "untaxed", "exempt"].map((s) => <SelectItem key={s} value={s}>{s.toUpperCase()}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          {FIELDS.map(([k, label, type]) => (
            <div key={k} className="space-y-1.5"><Label>{label}</Label><Input type={type} value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`compliance-${k}`} /></div>
          ))}
          <div className="flex justify-end sm:col-span-2"><button type="submit" data-testid="compliance-save-btn" className="rounded-full bg-primary px-6 py-2.5 text-sm font-bold text-primary-foreground">Save</button></div>
        </form>
      </DialogContent>
    </Dialog>
  );
};
